import { IconButton, IconButtonProps } from '@mui/material';

import CloseXIcon from 'modules/common/components/Icons/CloseXIcon';

function DialogCloseButton({ onClick = () => {}, ...props }: IconButtonProps) {
    return (
        <IconButton
            {...props}
            onClick={onClick}
            data-testid="dialog-close-button"
            sx={{
                position: 'absolute',
                right: 16,
                top: 10,
                ...props.sx,
            }}>
            <CloseXIcon fontSize="small" />
        </IconButton>
    );
}

export default DialogCloseButton;
